export const demographicTypes = [
  { title: 'State', value: 'state' },
  { title: 'Federal Electorate', value: 'ced' },
  { title: 'State Electorate', value: 'sed' },
  // { title: 'Suburbs', value: 'suburbs' },
  { title: 'Postcodes', value: 'postcodes' },
  { title: 'Custom List', value: 'custom' },
];

export const defaultAgeRanges = {
  // '1_Below_18': [
  //   0,
  //   18,
  // ],
  '2_18_to_34': [
    18,
    34,
  ],
  '3_35_to_50': [
    35,
    50,
  ],
  '4_51_to_65': [
    51,
    65,
  ],
  '5_Above_65': [
    65,
    200,
  ],
};

export const ageGenderTableHeaders = [
  { title: 'Age Bracket', value: 'key', divider: true },
  { title: 'Male Weighting', value: 'male' },
  { title: 'Female Weighting', value: 'female' },
];

export const statuses = {
  draft: {
    id: 'draft',
    icon: 'mdi-pencil',
    color: 'grey',
    message: 'Draft',
    description: 'The poll has not yet been submitted.',
    genericShortDescription: 'Polls not yet submitted.',
  },
  submitted: {
    id: 'submitted',
    icon: 'mdi-dots-horizontal-circle-outline',
    color: 'yellow-darken-2',
    message: 'Submitted',
    description: 'The poll has been submitted.',
    genericShortDescription: 'Polls submitted for approval.',
  },
  accepted: {
    id: 'accepted',
    icon: 'mdi-check-circle-outline',
    color: 'teal-lighten-1',
    message: 'Approved',
    description: 'The poll has been approved but has not yet begun.',
    genericShortDescription: 'Polls approved but not yet running.',
  },
  running: {
    id: 'running',
    icon: 'mdi-clipboard-clock-outline',
    color: 'blue',
    message: 'Running',
    description: 'The poll is actively running and collecting data.',
    genericShortDescription: 'Polls actively running.',
  },
  reporting: {
    id: 'reporting',
    icon: 'mdi-file-clock-outline',
    color: 'indigo-lighten-1',
    message: 'Pending Reports',
    description: 'The poll has completed. Your report is being prepared.',
    genericShortDescription: 'Polls awaiting reports.',
  },
  complete: {
    id: 'complete',
    icon: 'mdi-file-table-outline',
    color: 'green-accent-4',
    message: 'Complete',
    description: 'The poll has completed and your report is ready to download.',
    genericShortDescription: 'Polls completed with reports available.',
  },
};

export const mediums = {
  sms: {
    id: 'sms',
    display: 'SMS',
    icon: 'mdi-forum',
    linkAlias: 'sms',
  },
  pstn: {
    id: 'pstn',
    display: 'Voice',
    icon: 'mdi-phone',
    linkAlias: 'voice',
  },
};

export const defaultSendRates = {
  sms: 10000,
  pstn: 25000,
};

export const defaultQuestions = {
  gender: {
    id: 'qgen',
    prompt: `uComms
Short poll! Please take 2-min to complete.
Reply with your gender to start

Opt-out reply stop`,
    display: 'Gender',
    responses: [
      {
        response: '1_Male',
        keywords: ['1', 'male'],
      },
      {
        response: '2_Female',
        keywords: ['2', 'female'],
      },
      {
        response: '3_Other',
        keywords: ['3', 'other'],
        filteredOut: true,
      },
    ],
    options: ['Male', 'Female', 'Other'],
  },
  age: {
    id: 'qage',
    prompt: `To help us better understand your responses, please reply -
1: If you are under 18 years of age.
2: 18 - 34
3: 35 - 50
4: 51 - 64
5: If you are over 65 years of age.`,
    display: 'Age Bracket',
    responses: [
      {
        response: '1_Below_18',
        keywords: ['1'],
      },
      {
        response: '2_18_to_34',
        keywords: ['2'],
      },
      {
        response: '3_35_to_50',
        keywords: ['3'],
      },
      {
        response: '4_51_to_65',
        keywords: ['4'],
      },
      {
        response: '5_Above_65',
        keywords: ['5'],
      },
    ],
    options: ['Below 18', '18 to 34', '35 to 50', '51 to 65', 'Above 65'],
  },
};

export const defaultShortMethodologyDisclosureItems = [
  {
    "id": "research-conducted-by",
    "label": "Research conducted by",
    "value": "Yabbr Listens Pty Ltd"
  },
  {
    "id": "commissioned-by",
    "label": "Commissioned by",
    "value": "xxx"
  },
  {
    "id": "end-client",
    "label": "End client",
    "value": "xxx"
  },
  {
    "id": "fieldwork-dates",
    "label": "Fieldwork dates",
    "value": "xxx"
  },
  {
    "id": "mode-of-data-collection",
    "label": "Mode of data collection",
    "value": "Automated telephone poll and SMS"
  },
  {
    "id": "target-population",
    "label": "Target population",
    "value": "Automated telephone poll and SMS"
  },
  {
    "id": "sample-size",
    "label": "Sample size",
    "value": "xxx"
  },
  {
    "id": "apc-compliant",
    "label": "Australian Polling Council (APC) Compliant",
    "value": "Yes"
  },
  {
    "id": "url-of-long-methodology-disclosure-statement",
    "label": "URL of Long Methodology Disclosure Statement",
    "value": "https://ucommsapc.info/"
  },
  {
    "id": "voter-intention-published",
    "label": "Voter intention published",
    "value": "Yes"
  },
];

export const defaultLongMethodologyDisclosureItems = [
  {
    "id": "effective-sample-size",
    "label": "Effective sample size after weighting applied",
    "value": "xxx"
  },
  {
    "id": "margin-of-error",
    "label": "Margin of Error associated with effective sample size",
    "value": "xxx"
  },
  {
    "id": "variables-used-in-weighting",
    "label": "Variables used in weighting",
    "value": "Population distribution (Age x Gender)"
  },
  {
    "id": "weighting-methodology",
    "label": "Weighting methodology",
    "value": "Ranked weighting"
  },
  {
    "id": "full-question-text",
    "label": "Full question text, responses categories and randomisation",
    "value": "See within attached"
  },
  {
    "id": "proportion-of-landline-mobile-completed-samples",
    "label": "Proportion of landline/mobile completed samples",
    "value": "xxx"
  },
  {
    "id": "source-of-sample",
    "label": "Source of Sample",
    "value": "xxx"
  },
  {
    "id": "positioning-of-voter-intention-questions-within-survey",
    "label": "Positioning of voter intention questions within survey",
    "value": "First question after call and SMS intro"
  },
  {
    "id": "undecided-voter-handling",
    "label": "Undecided voter handling",
    "value": 'Respondents who answered "Undecided" were then asked a leaning question'
  },
  {
    "id": "2pp-calculation-method",
    "label": "2pp calculation method",
    "value": "Respondent allocated preferences"
  },
];

export const resultTotals = {
  display: 'Totals',
  id: 'totals',
  prompt: 'Totals',
  options: [],
};

export const result2pp = {
  display: 'Accumulated Preferences',
  id: '2pp',
  prompt: 'Accumulated Preferences',
  resultDisplay: '2pp',
  options: [],
};

export const presetQuestions = {
  federalVote: {
    prompt: 'If a Federal election were to be held today, who would receive your first preference vote?',
    options: [
      'Labor',
      'The Liberal National Party',
      'The Greens',
      "Pauline Hanson's One Nation",
      'Another party or candidate',
      'Undecided'
    ]
  },
  undecidedLeaning: {
    prompt: 'Being undecided, to which of the following do you have even a slight leaning?',
    options: [
      'Labor',
      'The Liberal National Party',
      'The Greens',
      "Pauline Hanson's One Nation",
      'Another party or candidate'
    ]
  },
  preferenceChoice: {
    prompt: 'If you had to choose, which of the following would you preference higher?',
    options: [
      'Labor',
      'The Liberal National Party'
    ]
  },
  previousVote: {
    prompt: [
      'Thinking back to the May 2022 Federal election,',
      'when the Liberal National Party was led by Scott Morrison and the Labor Party was led by Anthony Albanese,',
      'which of the following received your first preference vote?'
    ].join(' '),
    options: [
      'The Liberal National Party',
      'The Greens',
      'Labor',
      'United Australia Party',
      "Pauline Hanson's One Nation",
      'Another party or candidate',
      'Do not recall',
      'Did not vote'
    ]
  },
  voiceVote: {
    prompt: [
      "Thinking back to the referendum last year on the 'Voice to Parliament'",
      "for Indigenous Australians, did you vote 'Yes' or 'No'?"
    ].join(' '),
    options: [
      'Yes',
      'No',
      'Unsure',
      'Did not vote'
    ]
  },
  education: {
    prompt: 'What is your highest completed level of education?',
    options: [
      'High School: Grade 9-12',
      'Tafe certificate, diploma or vocational',
      'University degree',
      'Advanced University postgraduate degree'
    ]
  },
  importantIssue: {
    prompt: [
      'If an election were held today which of the following issues would be',
      'most important to you when deciding who would receive your vote?'
    ].join(' '),
    options: [
      'The Cost of Living',
      'Economic Management',
      'Housing and Rental Affordability',
      'Climate Change and the Environment',
      'Corruption and Integrity in Politics',
      'Health and Aged Care',
      'Immigration',
      'Crime',
      'Other'
    ]
  }
};

export const presetQuestionOptions = {
  approval: {
    options: [
      'Strongly approve',
      'Approve',
      'Unsure',
      'Disapprove',
      'Strongly disapprove'
    ]
  },
  yesNo: {
    options: [
      'Yes',
      'No',
      'Unsure'
    ]
  },
  support: {
    options: [
      'Strongly support',
      'Support',
      'Unsure',
      'Oppose',
      'Strongly oppose'
    ]
  }
};

export const timezones = [
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
  'Etc/UTC',
  'Pacific/Auckland',
];


